import { httpClient } from '@bcba/client-auth';
import { baseCropPledgePath } from '.';

export const creditorRejectCropPledge = async (
  cropPledgeUuid: string,
): Promise<void> => {
  const { data } = await httpClient.post(
    `${baseCropPledgePath}/${cropPledgeUuid}/reject`,
  );

  return data;
};
